import { NewExistingRadioActions } from './NewExistingRadioActions';

export const newExistingRadioReducer = (state = {}, action) => {
    switch (action.type) {
        case NewExistingRadioActions.CHANGE_NEW_PATIENT: {
            return {
                ...state,
                isNewPatient: action.isNewPatient,
            };
        }
        default:
            return state;
    }
};
